/**
 * Les matières qu'une liste de choix peut proposer : celles qui sont actives,
 * plus celles que la donnée en cours d'édition référence déjà.
 *
 * <p>Une matière désactivée ne se propose plus — mais un test, un groupe ou
 * une inscription qui la portait avant doit continuer de la nommer. Sans la
 * seconde moitié de la règle, rouvrir une telle fiche afficherait un sélecteur
 * vide, et l'enregistrer effacerait une affectation que personne n'a voulu
 * retirer.</p>
 *
 * @param current Identifiants déjà référencés par la donnée éditée.
 */
export function selectableSubjects<T extends { id: number; isActive?: boolean | null }>(
  subjects: readonly T[] | null | undefined,
  current: Iterable<number | null | undefined> = [],
): T[] {
  const kept = new Set<number>();
  for (const id of current) {
    if (id != null) kept.add(Number(id));
  }
  return (subjects ?? []).filter((s) => s.isActive === true || kept.has(s.id));
}
